// extracted by mini-css-extract-plugin
module.exports = {"error":"C_ck"};